import ajaxIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png';
import dahuaIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png';
import hikIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png';
import aiboxIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png';
import camectIcon from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/camectIconPortal.png';

export const INTEGRATION_ICON_MAP = {
    AJAX: ajaxIcon,
    DAHUA: dahuaIcon,
    HIKVISION: hikIcon,
    AIBOX: aiboxIcon,
    CAMECT: camectIcon,
};

export const getLinkedIntegrationType = (integrations, pin) => {
    const match = (integrations || []).find(integration => String(integration.pin) === String(pin));
    return match?.integrationType ?? null;
};

export const getLinkedIntegrationIcon = (integrations, pin) => {
    const integrationType = getLinkedIntegrationType(integrations, pin);
    return integrationType ? (INTEGRATION_ICON_MAP[integrationType] ?? null) : null;
};
